module.exports = __webpack_public_path__ + "img/rander.c3cff4a7.png";